import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown, Clock } from "lucide-react";
import { IMAGES } from "@/data";

const lines = ["AVANTI", "PIZZA &", "KEBAB"];

export default function Hero() {
  const { scrollY } = useScroll();
  const bgY = useTransform(scrollY, [0, 900], [0, 260]);
  const fade = useTransform(scrollY, [0, 500], [1, 0.2]);

  return (
    <section id="top" className="relative h-[100svh] min-h-[640px] overflow-hidden" data-testid="hero-section">
      <motion.div style={{ y: bgY }} className="absolute inset-0 -top-40 h-[calc(100%+20rem)]">
        <img src={IMAGES.hero} alt="Traditional Turkish mosaic lamps glowing in a row" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-coal-900/70" />
      </motion.div>

      <motion.div style={{ opacity: fade }} className="relative z-10 h-full max-w-7xl mx-auto px-6 flex flex-col justify-end pb-24">
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-ember mb-6" data-testid="hero-kicker">
          Mildura · Est. on Eighth St
        </p>
        <h1 className="font-display leading-[0.85] text-[22vw] sm:text-[16vw] lg:text-[11rem] text-hero-gold" data-testid="hero-heading">
          {lines.map((line, i) => (
            <span key={line} className="block overflow-hidden">
              <motion.span
                className="block"
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.9, delay: 0.25 + i * 0.16, ease: "circOut" }}
              >
                {i === 1 ? <span className="text-ember">{line}</span> : line}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.7 }}
          className="mt-8 flex flex-wrap items-center gap-6"
        >
          <a
            href="/order"
            data-testid="hero-order-button"
            className="inline-flex items-center gap-2 bg-ember hover:bg-ember-hover text-white font-semibold px-8 py-4 text-sm tracking-wide uppercase transition-colors duration-300 ember-glow"
          >
            Order Online
          </a>
          <span className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-zinc-400" data-testid="hero-hours-badge">
            <Clock className="w-4 h-4 text-ember" /> Open till 3AM Fri & Sat
          </span>
        </motion.div>
      </motion.div>

      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        className="absolute bottom-6 right-6 z-10 text-zinc-500"
      >
        <ArrowDown className="w-5 h-5" />
      </motion.div>
    </section>
  );
}
